<template>
  <div class="shoppe">
    <div class="query-form">
      <el-form label-position="right" label-width="100px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="账户别名">
                  <el-input v-model="queryForm.vendorNameAlias" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="账户名称">
                  <el-input v-model="queryForm.accountName" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="对应店铺别名">
                  <el-select v-model="queryForm.vendorAliasId" filterable clearable placeholder="别名">
                    <el-option v-for="item in vendorList" :label="item.vendorNameAlias" :value="item.vendorId" :key="item.vendorId"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="对应店铺">
                  <el-select v-model="queryForm.vendorId" filterable clearable placeholder="店铺">
                    <el-option v-for="item in vendorList" :label="item.vendorName" :value="item.vendorId" :key="item.vendorId"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
            <el-button @click="search" type="primary">查询</el-button>
            <el-button @click="reset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="tr">
      <el-button type="primary" @click="showForm">创建</el-button>
    </div>
    <el-table :data="tableData">
      <el-table-column prop="accountName" label="账户名称"></el-table-column>
      <el-table-column label="对应店铺别名" width="500">
        <template slot-scope="scope">
          <div class="vendor-name">{{ scope.row.stockLocationVOS && scope.row.stockLocationVOS.map(item => item.vendorNameAlias).join(', ') }}</div>
        </template>
      </el-table-column>
      <el-table-column label="对应店铺" width="500">
        <template slot-scope="scope">
          <div class="vendor-name">{{ scope.row.stockLocationVOS && scope.row.stockLocationVOS.map(item => item.vendorName).join(', ') }}</div>
        </template>
      </el-table-column>
      <el-table-column label="类目筛选">
        <template slot-scope="scope">
          {{ formatCategoryLabel(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="220">
        <template slot-scope="scope">
          <el-link type="primary" @click="showEditAccount(scope.row)">编辑</el-link>
          <el-link class="ml10" type="primary" @click="addCategory(scope.row)">增加筛选</el-link>
          <el-link class="ml10" type="primary" @click="resetAccount(scope.row)">重置密码</el-link>
          <el-link class="ml10" type="primary" v-if="scope.row.enabled" @click="stopAccount(scope.row)">停用</el-link>
          <el-link class="ml10" type="primary" v-if="!scope.row.enabled" @click="enabledAccount(scope.row)">启用</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="tr"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNo"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>

    <el-dialog append-to-body :title="form.userId ? '编辑账号' : '创建账号'" :visible.sync="dialogVisible" width="800px">
      <el-form ref="form" :model="form" label-width="150px">
        <el-form-item prop="accountName" label="账户名称" :rules="[{ required: true, message: '请输入账户名称' }, {max: 16, min: 4, message: '账号长度在4-16位'}]">
          <el-input :disabled="Boolean(form.userId)" v-model="form.accountName" style="width: 200px"></el-input>
        </el-form-item>
        <el-form-item prop="locationList" label="店铺/Stock Location" :rules="[{ required: true, message: '请选择店铺/Stock Location' }]">
          <el-input @click.native="showStockLocationPicker" style="width: 200px"></el-input>
          <div class="sl-group">
            <div class="sl-item" v-for="item in form.stockLocationVOS" :key="item.stockLocationId">
              {{ item.vendorName }}-{{ item.stockLocationName }}
              <i @click="delStockLocation(item)" class="el-icon-close icon-close"></i>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">提交</el-button>
      </span>
    </el-dialog>

    <el-dialog append-to-body title="添加筛选" :visible.sync="addCategoryDialogVisible" width="500px">
      <el-tree ref="tree"
        :data="categoryList"
        show-checkbox
        node-key="categoryId"
        @check-change="treeCheckChange"
        :props="{children: 'children', label: 'chineseName'}">
      </el-tree>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addCategoryDialogVisible = false">取 消</el-button>
        <el-button type="primary" :disabled="treeCheckcategoryIds.length == 0" @click="submitAddCategory">确认创建</el-button>
      </span>
    </el-dialog>

    <el-dialog append-to-body title="选择店铺/Stock Location" :visible.sync="pickerDialogVisible" width="800px">
      <el-input v-model="filterVendorName" placeholder="输入筛选店铺" style="margin-bottom: 10px"></el-input>
      <div class="store-wrap">
        <dl class="store-list" v-for="store in pickerStockLocationList.filter(item => item.vendorName.toUpperCase().indexOf(filterVendorName.toUpperCase()) > -1)" :key="store.vendorId">
          <dt class="store-name">{{ store.vendorName }}</dt>
          <dd class="store-stocklocation-list">
            <el-radio-group v-model="store.locationId">
              <el-radio :label="null">不选</el-radio>
              <el-radio v-for="item in store.merchantStockLocationDtos" :key="item.locationId" :label="item.locationId">{{ item.stockLocation }}</el-radio>
            </el-radio-group>
          </dd>
        </dl>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="pickerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitVendorStockLocation">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getMerchantVendorList,
  getVendorStockLocation,
  getMerchantList,
  createAccount,
  editAccount,
  stopAccount,
  enabledAccount,
  resetAccount,
  updateStockLocationCategory,
  getVendorAndStockLocationList,
} from "./api";
import { getCategory, } from '../../api/mapping';

export default {
  components: {
  },
  data() {
    return {
      queryForm: {
        vendorAlias: null,
        accountName: null,
        vendorAliasId: null,
        vendorId: null,
        pageNo: 1,
        pageSize: 25,
      },
      vendorList: [],
      tableData: [],
      total: 0,
      dialogVisible: false,
      form: {
        userId: null,
        accountName: null,
        locationList: [],
        stockLocationVOS: [],
      },
      categoryList: [],
      addCategoryDialogVisible: false,
      treeCheckcategoryIds: [],
      pickerDialogVisible: false,
      pickerStockLocationList: [],
      filterVendorName: '',
    };
  },
  mounted() {
    getMerchantVendorList().then(res => {
      if (res.data && res.data.data) {
        this.vendorList = res.data.data;
      }
    });
    getCategory().then(res => {
      if (res.data && res.data.data) {
        this.categoryList = res.data.data;
        this.selectedAllIds = []
        this.categoryList.forEach(item => {
          item.children.forEach((item2) => {
            item2.children.forEach(item3 => {
              this.selectedAllIds.push(item3.categoryId)
            })
          })
        })
        this.getTableData();
      }
    })
  },
  methods: {
    search() {
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    reset() {
      this.queryForm.vendorNameAlias = null;
      this.queryForm.accountName = null;
      this.queryForm.vendorAliasId = null;
      this.queryForm.vendorId = null;
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    getTableData() {
      getMerchantList({
        ...this.queryForm,
        accountName: this.queryForm.vendorNameAlias || this.queryForm.accountName,
        vendorId: this.queryForm.vendorAliasId || this.queryForm.vendorId,
      }).then(res => {
        if (res.data && res.data.data) {
          this.total = res.data.data.total;
          this.tableData = res.data.data.list;
        }
      })
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      this.getTableData();
    },
    formatCategoryLabel(row) {
      if (!row.productCategoryIds) {
        return ''
      }
      if (row.productCategoryIds === '-1') {
        return '全部'
      }
      return '有筛选';
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.repeatSave) {
            this.repeatSave = true;
            let request = createAccount;
            if (this.form.userId) {
              request = editAccount;
            }
            request(this.form).then(res => {
              this.repeatSave = false;
              if (res.data.success) {
                this.$message.success(this.form.userId ? '编辑成功' : '创建成功');
                this.dialogVisible = false;
                this.getTableData();
              } else {
                this.$message.error(res.data.data || res.data.message);
              }
            }).catch((err) => {
              this.repeatSave = false;
            })
          }
        } else {
          this.$message.error('请完善信息');
          return false;
        }
      });
    },
    resetAccount(row) {
      this.$confirm(`确认重置${row.accountName}账号密码吗?`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        resetAccount({
          userId: row.userId
        }).then(() => {
          this.$message({
            type: 'success',
            message: '操作成功!'
          });
          this.getTableData();
        })
      }).catch(() => {});
    },
    stopAccount(row) {
      this.$confirm(`确认停用${row.accountName}账号吗?`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        stopAccount({
          userId: row.userId
        }).then(() => {
          this.$message({
            type: 'success',
            message: '操作成功!'
          });
          this.getTableData();
        })
      }).catch(() => {});
    },
    enabledAccount(row) {
      this.$confirm(`确认启用${row.accountName}账号吗?`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        enabledAccount({
          userId: row.userId
        }).then(() => {
          this.$message({
            type: 'success',
            message: '操作成功!'
          });
          this.getTableData();
        })
      }).catch(() => {});
    },
    showForm() {
      this.form.userId = null;
      this.form.accountName = null;
      this.form.locationList = [];
      this.form.stockLocationVOS = [];
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      })
    },
    showEditAccount(row) {
      this.form.userId = row.userId;
      this.form.accountName = row.accountName;
      this.form.locationList = row.stockLocationVOS.map(item => ({ vendorId: item.vendorId, stockLocationId: item.stockLocationId }));
      this.form.stockLocationVOS = JSON.parse(JSON.stringify(row.stockLocationVOS));
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      })
    },
    addCategory(row) {
      this.addCategoryDialogVisible = true;
      this.userId = row.userId;
      this.$nextTick(() => {
        if (row.productCategoryIds == '-1') {
          this.$refs.tree.setCheckedKeys(this.selectedAllIds);
        } else if (row.productCategoryIds) {
          this.$refs.tree.setCheckedKeys(row.productCategoryIds.split(','));
        } else {
          this.$refs.tree.setCheckedKeys([]);
        }
      })
    },
    submitAddCategory() {
      const categoryIds = this.$refs.tree.getCheckedKeys(true)
      let ids = '';
      if (categoryIds.length === this.selectedAllIds.length) {
        ids = '-1'
      } else {
        ids = categoryIds.join(',')
      }
      updateStockLocationCategory({
        userId: this.userId,
        categoryIds: ids
      }).then(res => {
        this.$message({
          type: 'success',
          message: '操作成功!'
        });
        this.addCategoryDialogVisible = false;
        this.getTableData();
      })
    },
    treeCheckChange() {
      this.treeCheckcategoryIds = this.$refs.tree.getCheckedKeys(true)
    },
    showStockLocationPicker() {
      const slIds = this.form.locationList.map(item => item.stockLocationId);
      getVendorAndStockLocationList({
        userId: this.form.userId,
      }).then(res => {
        this.pickerStockLocationList = (res.data.data || []).map(item => {
          const flag = item.merchantStockLocationDtos.some(sl => {
            if (slIds.indexOf(sl.locationId) > -1) {
              item.locationId = sl.locationId;
              return true;
            }
            return false;
          })
          if (!flag) {
            item.locationId = null;
          }
          return item;
        });
        this.filterVendorName = '';
        this.pickerDialogVisible = true;
      })
    },
    submitVendorStockLocation() {
      const data = [];
      this.pickerStockLocationList.forEach(item => {
        if (item.locationId) {
          item.merchantStockLocationDtos.some(sl => {
            if (sl.locationId === item.locationId) {
              data.push({
                vendorId: item.vendorId,
                vendorName: item.vendorName,
                stockLocationId: sl.locationId,
                stockLocationName: sl.stockLocation,
              })
              return true;
            }
            return false;
          })
        }
      });
      this.form.locationList = data.map(item => ({ vendorId: item.vendorId, stockLocationId: item.stockLocationId }))
      this.form.stockLocationVOS = data;
      this.pickerDialogVisible = false;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      })
    },
    delStockLocation(sl) {
      this.form.locationList.some((item, index) => {
        if (item.stockLocationId === sl.stockLocationId) {
          this.form.locationList.splice(index, 1);
          this.form.stockLocationVOS.splice(index, 1);
          return true;
        }
        return false;
      })
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.ml10 {
  margin-left: 10px;
}
.store-wrap {
  max-height: 500px;
  overflow: auto;
}
.store-list {
  display: flex;
  margin-bottom: 2px;
  border: 1px solid #DCDFE6;
  border-radius: 5px;

  .store-name {
    flex: 0 0 auto;
    width: 150px;
    padding: 10px;
    border-right: 1px solid #DCDFE6;
  }
  .store-stocklocation-list {
    padding: 10px;
  }
}
.sl-group {
  display: flex;
  flex-wrap: wrap;

  .sl-item {
    margin-right: 10px;
    margin-top: 10px;
    padding: 0 5px;
    line-height: 30px;
    border: 1px solid #DCDFE6;
    border-radius: 4px;
  }
  .icon-close:hover {
    color: #409EFF;
  }
}
.vendor-name {
  white-space:nowrap;
  text-overflow:ellipsis;
  overflow:hidden; 
}
</style>
